import { useState, useCallback } from "react";

/**
 * Hook to manage a session-based end time that persists across pagination
 * but resets when the user manually refreshes
 */
export const useSessionEndTime = () => {
  // Initialize with current time immediately
  const [sessionEndTime, setSessionEndTime] = useState<Date>(() => new Date());

  const resetSessionEndTime = useCallback(() => {
    setSessionEndTime(new Date());
  }, []);

  return {
    sessionEndTime,
    resetSessionEndTime,
  };
};
